"use client";

import { useSetTheme, useThemeConfigStore } from "@marginly/ui/stores/theme";
import React, { useMemo, useState } from "react";
import type { Chain } from "viem";

import { onThemeChange } from "@/actions/theme";
import type { onWalletConnect, onWalletDisconnect } from "@/actions/wallet";
import { Web3Provider } from "@/contexts/web3";
import { MarginlyApiContext } from "@/hooks/api";
import { FIX_CHAIN_ID, patchChain } from "@/util/viem-ext";

interface ProviderProps {
  serverTime: number;
  apiBaseurl: string;
  chain: Chain;
  children: React.ReactNode;
  disableFeatures?: string[];
  onWalletConnect?: typeof onWalletConnect;
  onWalletDisconnect?: typeof onWalletDisconnect;
  projectId: string;
}
export function Provider({
  apiBaseurl,
  children,
  chain: _chain,
  disableFeatures,
  onWalletConnect,
  onWalletDisconnect,
  serverTime: _serverTime,
  projectId,
}: ProviderProps) {
  const [serverTime] = useState(() => _serverTime);
  const theme = useThemeConfigStore();
  useSetTheme({ theme, onChange: onThemeChange });

  const chains = useMemo(
    () => [FIX_CHAIN_ID.includes(_chain.id) ? patchChain(_chain) : _chain],
    [_chain],
  );

  return (
    <MarginlyApiContext.Provider value={{ baseurl: apiBaseurl, serverTime }}>
      <Web3Provider
        projectId={projectId}
        chains={chains}
        pools={[]}
        onWalletConnect={onWalletConnect}
        onWalletDisconnect={onWalletDisconnect}
        disableFeatures={disableFeatures}
      >
        {children}
      </Web3Provider>
    </MarginlyApiContext.Provider>
  );
}
